// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.
import { mergeStyles } from '@fluentui/react';
import { MoreIcon, Ref } from '@fluentui/react-northstar';
import React from 'react';
import { chatActionsCSS, iconWrapperStyle } from '../styles/ChatMessageComponent.styles';
/**
 * Props for the Chat.Message action menu.
 * This is the 3 dots that appear when hovering over one of your own chat messages.
 *
 * @private
 */
export const chatMessageActionMenuProps = (menuProps) => {
    if (!menuProps.enabled) {
        return undefined;
    }
    const menuClass = mergeStyles(chatActionsCSS, {
        'ul&': { boxShadow: menuProps.theme.effects.elevation4, backgroundColor: menuProps.theme.palette.white }
    });
    const actionMenuProps = {
        showActionMenu: menuProps.forceShow === true ? true : undefined,
        iconOnly: true,
        activeIndex: -1,
        className: menuClass,
        onItemClick: () => menuProps.onActionButtonClick(),
        items: [
            {
                children: (React.createElement(Ref, { innerRef: menuProps.menuButtonRef },
                    React.createElement(MoreIcon, Object.assign({ className: iconWrapperStyle }, {
                        outline: true
                    })))),
                key: 'menuButton',
                indicator: false
            }
        ]
    };
    return actionMenuProps;
};
//# sourceMappingURL=ChatMessageActionMenu.js.map